import type { Profile } from '@/http/zamply/user/get-profile-schema'

interface ProfileEnvelope {
  data?: Profile | null
}

export function unwrapProfile(payload: unknown): Profile | null {
  if (!payload || typeof payload !== 'object') {
    return null
  }

  if ('full_name' in payload && 'reference' in payload) {
    return payload as Profile
  }

  const envelope = payload as ProfileEnvelope
  if (envelope.data && typeof envelope.data === 'object') {
    return unwrapProfile(envelope.data)
  }

  return null
}
